import React, { Component } from 'react';

import Home from './Home.js';
import Workshops from './Workshops/Workshops.js';
import Gallery from './Gallery.js';
import Essays from './Essays.js';
import About from './About/About.js';
import Footer from './Footer.js';

class ScrollTest extends Component {
    render() {
        return (
            <div className="portfolio-pages">
                <div className="portfolio-page"><Home /></div>
                <div className="portfolio-page"><About /></div>
                <div className="portfolio-page"><Workshops /></div>
                <div id="gallery" className="portfolio-page long-page long-gallery" ref={this.longPageRef}><Gallery /></div>
                <div className="portfolio-page"><Essays /></div>
                <div className="portfolio-page"><Footer /></div>
            </div>
        );
    }
}

export default ScrollTest;
